<div class="devtool"
     *ngIf="showDevTool"
     [style.left.px]="position.x"
     [style.top.px]="position.y"
     (mousedown)="onMouseDown($event)"
     (mousemove)="onMouseMove($event)"
     (mouseup)="onMouseUp()"
     (mouseleave)="onMouseUp()">
  <button class="devtool-button"
          [class.active]="showMenu"
          (click)="toggleMenu()"><fa-icon [icon]="faMagicWandSparkles"></fa-icon></button>

  <div class="devtool-menu" *ngIf="showMenu">
    <button [class.active]="showAccounts" (click)="showAccountList()">Change Account</button>
    <button [class.active]="showPassports" (click)="showPassportList()">Fake Passport</button>
    <button (click)="clearStorage()">Clear storage</button>
    <button (click)="windowReload()">Reload window</button>
    <button (click)="showDevTool = false">Hide Dev Tool</button>
    <button *ngIf="api.isElectronApp" (click)="openInspector()">Open Inspector</button>
    <button (click)="api.signOut()">Sign out</button>

    <div class="accounts-list" *ngIf="showAccounts">
      <div class="account-item" *ngFor="let account of config.accounts" (click)="selectAccount(account)">
        {{account.name}}
      </div>
    </div>

    <div class="passports-list" *ngIf="showPassports">
      <div class="passport-item">
        <label>
          <input type="radio"
                 [checked]="!api.devtoolFakePassport"
                 (change)="togglePassport(null)">
          None (Use Real Passport)
        </label>
      </div>
      <div class="passport-item" *ngFor="let passport of config.fakePassports">
        <label>
          <input type="radio"
                 [checked]="api.devtoolFakePassport?.name === passport.name"
                 (change)="togglePassport(passport.name)">
          <ol>
            <li><b>{{passport.name}}</b></li>
            <li>{{passport.data.documentNumber}}</li>
            <li>{{passport.data.fields.firstName}} {{passport.data.fields.lastName}}</li>
          </ol>
        </label>
      </div>
    </div>
  </div>
</div>
